import { render } from "./Rightside.vue?vue&type=template&id=09a61029&ts=true"
import script from "./Rightside.vue?vue&type=script&lang=ts"
export * from "./Rightside.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__